import {CognitoUserPool} from 'amazon-cognito-identity-js'

const poolData = {
    UserPoolId: 'us-east-1_eJAJ58Tn9',
    ClientId: '64gj3lgigtf2jfl3a2j74t1vg9'
}

export default new CognitoUserPool(poolData)